import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { ScheduleModule } from '@nestjs/schedule';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { RequestForm } from './visitor-request/entity/request.entity';
import { RequestModule } from './visitor-request/request.module';
import  { VisitorEntry } from './visitor-request/entity/security.entity';


@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: 'mysql',
      // host: '206.189.138.212',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.vms_db,
      entities: [RequestForm,VisitorEntry],
      synchronize: false,
      logging: true
    }),
    RequestModule ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
